<app-loader></app-loader>
<div class="app-main-container">
    <div class="main-layout">
        <!-- Sidebar Container -->
        <div id="sidebar-container" [class.collapsed]="isCollapsed" *ngIf="isLoggedIn && !isNewUser" #sidebar>
            <!-- Logo Section -->
            <div class="sidebar-logo" [ngClass]="{ 'collapsed-logo': isCollapsed }">
                <img [src]="isCollapsed ? 'assets/images/Logo_Small.png' : 'assets/images/Logo.png'"
                    class="logo-image" />
            </div>

            <ul class="list-group menu-items">
                <div *ngFor="let menuItem of menuOptions" [class.nav-disabled]="disableNavButtons"
                    [style.opacity]="disableNavButtons ? '0.5' : '1'">
                    <li class="list-group-item" [title]="menuItem.label"
                        *ngIf="menuItem.label && menuItem.label !== 'BooksTree' && (menuItem.permissionRequired === undefined || permissions?.includes(menuItem.permissionRequired))"
                        [class.active]="isActiveRoute(menuItem.route)"
                        (click)="navigateToClickTarget(menuItem)">
                        <img [src]="'assets/icons/' + menuItem.icon" class="menu-icon" alt="{{ menuItem.label }}" />
                        <span>{{ menuItem.label }}</span>
                    </li>
                    <li class="list-group-item-tree"
                        *ngIf="menuItem.label && menuItem.label === 'BooksTree' && (menuItem.permissionRequired === undefined || permissions?.includes(menuItem.permissionRequired))"
                        [class.active]="isActiveRoute(menuItem.route)"
                        (click)="navigateToClickTarget(menuItem)">
                        <app-tree class="app-tree-container" *ngIf="isCollapsed == false" [permissions]="permissions"
                            style="width: 100%;"></app-tree>
                    </li>
                </div>
            </ul>
            <!-- Profile Dropdown -->
            <div class="profile-container" [class.nav-disabled]="disableNavButtons" [title]="userInfo?.Fullname"
                [style.opacity]="disableNavButtons ? '0.5' : '1'">
                <button
                    class="btn btn-secondary dropdown-toggle dropdown-btn d-flex align-items-center gap-2 profile-btn"
                    type="button" data-bs-toggle="dropdown" aria-expanded="false" [title]="userInfo?.Fullname"
                    [disabled]="disableNavButtons">
                    <img [src]="safePictureUrl" class="profile-pic rounded-circle" alt="Profile"
                        (error)="onImageError($event)" />
                    <span class="custom-ellipsis text-truncate" *ngIf="!isCollapsed">{{ userInfo?.Fullname }}</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end custom-dropdown">
                    <ng-container *ngFor="let option of dropdownOptions">
                        <li *ngIf="option.label !== 'divider'" style="padding: 0 6px; margin: 6px 0;">
                            <a class="dropdown-item custom-ellipsis" [title]="option.label"
                                (click)="!disableNavButtons && onDropdownItemClick(option)"
                                [class.active]="isDropdownItemActive(option)">
                                {{ option.label }}
                            </a>
                        </li>
                        <div *ngIf="option.label === 'divider'" class="dropdown-divider"></div>
                    </ng-container>
                </ul>
            </div>

            <!-- Collapse Control -->
            <div class="list-group-item toggle-collapse" (click)="!disableNavButtons && toggleSidebar()"
                *ngIf="showExpandSideBarControl">
                <i [class.fa-angle-double-left]="!isCollapsed" [class.fa-angle-double-right]="isCollapsed"
                    class="fa"></i>
            </div>

            <!-- Resize Handle -->
            <div class="resize-handle" (mousedown)="startResize($event)"></div>
        </div>

        <!-- Router Outlet Container -->
        <div class="router-outlet-container">
            <div class="bottom-container">
                <router-outlet></router-outlet>
            </div>
            <div class="footer-container">
              <div class="copyright-content" #copyrightContent>
                <span style="margin-right: 20px;">© 2025 GrapeCity India Pvt. Ltd. All Rights Reserved.</span>
              </div>
              <div *ngIf="!isLoggedIn" class="terms-and-conditions-container">
                <a class="policy-item" [href]="serviceURLS.termsOfServiceURL" target="_blank">Terms of Service</a>
                <span class="policy-item-pipe">|</span>
                <a class="policy-item" [href]="serviceURLS.privacyPolicyURL" target="_blank">Privacy Policy</a>
              </div>
            </div>
        </div>
    </div>
</div>
